<template>
  <v-container fluid fill-height class="login-page-container">
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="10" sm="7" md="4" class="login-card-wrapper">
        <v-form ref="form" @submit.prevent="onSubmit">
          <h1 class="login-title mb-8">Immanuel Seoul Admin</h1>

          <v-text-field
            v-model="email"
            label="아이디를 입력하세요."
            required
            outlined
            class="mb-2"
          ></v-text-field>

          <v-text-field
            v-model="password"
            :append-icon="show4 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show4 ? 'text' : 'password'"
            label="비밀번호를 입력하세요."
            @click:append="show4 = !show4"
            outlined
            class="mb-4"
          ></v-text-field>

          <v-btn
            block
            :disabled="!(email && password).trim()"
            color="primary"
            class="mb-4"
            x-large
            depressed
            @click="onSubmit"
          >
            로그인
          </v-btn>

          <v-btn
            block
            color="secondary"
            x-large
            depressed
            @click="onRegister"
          >
            사용자 등록
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { user } from '../api'
import sha256 from 'crypto-js/sha256'
import principal from '../utils/principal'
import eventBus from '../utils/eventBus'

export default {
  data () {
    return {
      show4: false,
      password: '',
      email: ''
    }
  },
  methods: {
    async onSubmit () {
      try {
        const { data } = await user.signIn(this.email, sha256(this.password).toString())
        principal.storePrincipal(data.token)
        const redirect = this.$route.query.redirect || '/admin'
        await this.$router.push({ path: redirect })
      } catch (e) {
        if (e.response) {
          eventBus.$emit('alert', { active: true, text: e.response.data.message, type: 'error' })
        }
      }
    },
    onRegister () {
      this.$router.push({ path: '/admin/user-register' })
    }
  },
  created () {
    // [중요] 기존에 있던 viewport 삭제 로직을 반드시 제거해야 합니다.
    // 모바일 대응의 핵심은 viewport 메타 태그입니다.
  }
}
</script>

<style scoped lang="scss">
/* 기존 @include form-content; 가 레이아웃을 깨뜨릴 수 있으므로
   직접 필요한 스타일만 정의합니다. */

.login-page-container {
  min-height: 100vh;
  background-color: #f8f9fa; /* 배경색 */
  margin: 0;
  padding: 0;
}

.login-card-wrapper {
  /* PC 모니터가 아무리 커져도 폼이 무한정 넓어지지 않게 제한합니다. */
  max-width: 420px !important;
  width: 100%;
  padding: 20px;
  background: white; /* 폼 배경을 흰색으로 하고 싶을 때 */
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.05); /* 약간의 입체감 */
}

.login-title {
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
  color: #333;
  word-break: keep-all;
}

/* Vuetify 기본 텍스트 필드 높이 조정 (모바일 터치 최적화) */
::v-deep .v-input__control {
  min-height: 56px !important;
}
</style>
